function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    style: {
      enableBackground: "new 0 0 128 128"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.59,51.16c-4.23,0.92-7.88,3.28-9.59,7.35c-1.03,2.47-2.47,8.85-6.42,7.2 c-1.89-0.78-1.86-3.49-1.64-5.18c0.47-3.47,2.03-6.64,3.1-9.94c1.1-3.42,2.05-6.86,2.73-10.4c2.28-11.72,1.65-25.22-6.64-34.59 c-1.4-1.6-4.93-5.3-7.26-5.38c-1.44-0.04-0.02,1.66,0.38,2.23c0.81,1.17,1.49,2.44,2.01,3.77c6.13,15.64-8.98,27.55-18.91,36.82 c-4.76,4.45-8.56,9.17-11.98,14.68c-0.34,0.53-1.09,2.31-2.06,1.94c-1.15-0.44-1.27-3.07-1.63-4.05c-0.68-1.88-1.73-3.93-3.08-5.4 c-2.61-2.86-6.26-4.79-10.21-4.53c-0.15,0.01-0.58,0.08-1.11,0.2c-0.83,0.18-3.05,0.47-2.45,1.81c0.31,0.69,1.22,0.63,1.87,0.82 c8.34,2.56,8.15,11.3,6.8,18.32c-2.44,12.78-9.2,24.86-4.4,38c5.66,15.49,23.38,25.16,39.46,22.5c4.39-0.72,9.45-2.14,13.39-4.26 c4.19-2.26,8.78-5.35,12.05-8.83c4.21-4.47,6.89-10.2,7.68-16.27c0.93-7.02-1.31-13.64-3.35-20.27c-2.46-8-5.29-21.06,4.93-24.97 c0.5-0.2,1.5-0.35,1.85-0.88C105.41,49.91,99.17,51.04,98.59,51.16z",
    style: {
      fill: "#ED6C30"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.13,106.07c2.12,1.78,5.09,0.91,7.09-0.61c1.07-0.81,1.99-1.85,2.59-3.06 c0.25-0.52,0.54-1.18,0.54-1.77c0-0.79-0.47-1.57-0.27-2.38c1.68-0.33,3.76,4.5,3.97,5.62c1.68,8.83-6.64,16.11-14.67,17.52 c-13.55,2.37-21.34-9.5-19.78-20.04c0.97-6.56,5.37-11.07,9.85-15.57c3.71-3.73,7.15-6.93,8.35-11.78 c0.21-0.86,0.16-2.18-0.09-3.03c-0.21-0.73-0.61-1.4-0.63-2.19c-0.06-1.66,1.55,0.51,1.92,0.93c4.46,5.03,5.73,12.46,4.54,18.96 c-0.77,4.2-3.77,7.2-4.82,11.22C66.11,102.18,66.17,104.41,68.13,106.07z",
    style: {
      fill: "#FCC21B"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fire-icon.48c935ec0a963785d4bc663173355255.svg";
export { ForwardRef as ReactComponent };